import { cn } from '@/lib/utils';

interface TagProps {
  content: string;
  className?: string;
  color?: string;
  key?: string;
}

const Tag = ({
  content,
  className,
  color = 'hsl(var(--secondary))',
  key,
}: TagProps) => {
  return (
    <p
      key={key}
      className={cn(
        'w-fit rounded-full px-2 py-0.5 text-xs text-white',
        className,
      )}
      style={{ backgroundColor: color }}
    >
      {content}
    </p>
  );
};

export default Tag;
